import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
        computed,
        ComputedRef
    } from 'vue'
    import {
        IMutedStyling,
        IFeedbackStyling
    } from '@/interfaces'
    import time from '@/store/time'
    import status from '@/store/status'
    import updateScore from '@/utilities/updateScore'
    import GenericButton from './GenericButton.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    choice: null,
    selection: null,
    level: null,
    wasAnswered: { type: Boolean },
    isCorrect: { type: Boolean }
  },
  emits: ["getFeedback"],
  setup(__props: any, { emit }: { emit: ({
        (
            event: 'getFeedback',
            choice: number,
            isCorrect: boolean
        ): void
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        choice: number
        selection: number
        level: number
        wasAnswered: boolean
        isCorrect: boolean
    }

    

    

    const mutedStyling: ComputedRef<IMutedStyling> = computed(() => {
        const muted: boolean = props.wasAnswered || time.value === 0 || status.hasWon || status.hasLost
        const stylingObject: IMutedStyling = {
            muted
        }

        return stylingObject
    })

    const feedbackStyling: ComputedRef<IFeedbackStyling> = computed(() => {
        const red: boolean = !props.isCorrect && (time.value === 0 || props.wasAnswered) && props.selection === props.choice
        const green: boolean = props.isCorrect && (time.value === 0 || props.wasAnswered)
        const stylingObject: IFeedbackStyling = {
            red,
            green
        }

        return stylingObject
    })

    function grade(): void {
        if (!props.wasAnswered && time.value !== 0) {
            updateScore(props.level, props.isCorrect)
            emit('getFeedback', props.choice, props.isCorrect)
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(_unref(feedbackStyling))
  }, [
    _createVNode(GenericButton, {
      text: props.choice.toString(),
      class: _normalizeClass(_unref(mutedStyling)),
      onClick: grade
    }, null, 8, ["text", "class"])
  ], 2))
}
}

})